import { InputAgeLogic as InputAge } from './InputAge.logic'

export default InputAge
